// extracted by mini-css-extract-plugin
module.exports =  {"WelcomeScreenStartFormContainer":"WelcomeScreenStartForm__WelcomeScreenStartFormContainer--9765e"};